import type { S2C, DeathCard } from '../protocol/messages';
import type { GhostSnapshot, PlayerEnt } from '../sim/types';
import type { RealmRoom } from './realmRoom';
import type { DuelRoom } from './duelRoom';

/** A connected player as seen by rooms; the transport is abstracted behind send(). */
export interface Session {
  sid: number;
  accountId: string;
  name: string;
  avatar: number;
  send(m: S2C): void;
}

/** Persistence and orchestration callbacks supplied by the server (or the offline host). */
export interface RoomHost {
  newGhostId(): string;
  onDeath(room: RealmRoom, p: PlayerEnt, card: DeathCard, ghost: GhostSnapshot): void;
  /** called once when the realm has fully closed; the host moves sessions elsewhere */
  onRealmClosed(room: RealmRoom): void;
  /** fame/stat persistence for a player leaving a realm alive or after the boss */
  onPlayerResult(room: RealmRoom, p: PlayerEnt, reason: 'leave' | 'realmEnd'): void;
  onDuelEnd(room: DuelRoom, winner: Session | null, loser: Session | null): void;
  onRevenantSlain?(room: RealmRoom, ghost: GhostSnapshot, killerName: string): void;
  /** return false to block a chat message */
  onChat?(room: RealmRoom | DuelRoom, session: Session, text: string): boolean;
  /** takes fame from the account for a paid respec; false when it cannot pay (offline hosts leave it undefined: free) */
  spendFame?(session: Session, amount: number): boolean;
  /** show mode: charges the spectator and credits the watched account its share; false when the viewer cannot pay */
  crowdPay?(viewer: Session, targetAccountId: string, amount: number, share: number): boolean;
  /** show mode gate of the watched account */
  showModeOf?(accountId: string): boolean;
  /** the hero finished the leave cast: the host may now pull the session out of the realm */
  onLeaveReady?(room: RealmRoom, session: Session): void;
}

export const AOI_RADIUS = 1150;
